import React, { useState } from "react";

let accordionInstance = 0;

export const Accordion = ({
  content,
  text,
  initialState,
  alwaysOpen,
  status,
  eligible,
  ...anchorProps
}) => {
  const [expanded, setExpanded] = useState(initialState !== false);
  const [instanceId] = useState(() => ++accordionInstance);
  const toggleId = `cred-accordion-toggle-${instanceId}`;
  const contentId = `cred-accordion-content-${instanceId}`;

  function expand() {
    if (alwaysOpen || !initialState) {
      return;
    }
    setExpanded(!expanded);
  }

  return (
    <div
      className="mdn-Accordion"
      aria-label="Accordion Control Group"
      onClick={expand}
    >
      <div
        className={`mdn-Accordion-box ${expanded ? "is-expanded" : ""}`}
        aria-label="Acordion clicável para expandir o conteúdo"
        style={{
          cursor:
            status === "DISPONIVEL" && !eligible ? "default" : "",
        }}
      >
        <button
          {...anchorProps}
          type="button"
          id={toggleId}
          className="mdn-Accordion-toggle mdn-Text mdn-Text--body"
          aria-controls={contentId}
          aria-expanded={expanded}
        >
          {text}
          {status === "DISPONIVEL" && !eligible ? null : (
            <i
              className="mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--lg"
            ></i>
          )}
        </button>
        <div
          id={contentId}
          className="mdn-Accordion-content"
          role="region"
          aria-labelledby={toggleId}
          aria-hidden={!expanded}
        >
          <p className="mdn-Text mdn-Text--body">{content}</p>
          <i></i>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
